// src/MathTools/CountingTool.js
import React, { useState } from "react";

/**
 * CountingTool
 * 
 * Props:
 *   showPermutations?: boolean (default true) 
 *   showCombinations?: boolean (default true)
 * 
 * Example usage:
 *   <CountingTool showPermutations showCombinations />
 */
export default function CountingTool({
  showPermutations = true,
  showCombinations = true
}) {
  // state for n, k
  const [n, setN] = useState(5);
  const [k, setK] = useState(2);

  // simple factorial function (naive):
  function factorial(x) {
    if (x < 0) return NaN;
    if (x <= 1) return 1;
    let f = 1;
    for (let i = 2; i <= x; i++) {
      f *= i;
    }
    return f;
  }

  // permutations nPk = n! / (n-k)!
  function permutations(nVal, kVal) {
    if (kVal > nVal || nVal < 0 || kVal < 0) return 0;
    return factorial(nVal) / factorial(nVal - kVal);
  }

  // combinations nCk = n! / (k! * (n-k)!)
  function combinations(nVal, kVal) {
    if (kVal > nVal || nVal < 0 || kVal < 0) return 0;
    return factorial(nVal) / (factorial(kVal) * factorial(nVal - kVal));
  }

  // compute values
  const permValue = showPermutations
    ? permutations(n, k)
    : null;

  const combValue = showCombinations
    ? combinations(n, k)
    : null;

  return (
    <div style={{ border: "1px solid #ccc", padding: "12px", marginTop: "1em" }}>
      <h4>Counting Tool</h4>
      
      <div style={{ marginBottom: 8 }}>
        <label style={{ marginRight: 6 }}>
          n:{" "}
          <input
            type="number"
            value={n}
            onChange={e => setN(parseInt(e.target.value) || 0)}
            style={{ width: 60 }}
          />
        </label>
        
        <label style={{ marginRight: 6 }}>
          k:{" "}
          <input
            type="number"
            value={k}
            onChange={e => setK(parseInt(e.target.value) || 0)}
            style={{ width: 60 }}
          />
        </label>
      </div>
      
      {/* Show permutations if requested */}
      {showPermutations && (
        <p>
          <strong>P(n,k) = nPk:</strong>{" "}
          {permValue.toLocaleString()}
        </p>
      )}
      
      {/* Show combinations if requested */}
      {showCombinations && (
        <p>
          <strong>C(n,k) = nCk:</strong>{" "}
          {combValue.toLocaleString()}
        </p>
      )}
      
      <p style={{ fontSize: "0.9em", color: "#777", marginTop: 8 }}>
        (Computes exact factorial-based results for small n. 
         For large n, numbers can get huge quickly.)
      </p>
    </div>
  );
}
